
import { Label } from "@/components/ui/label";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { useTranslation } from "react-i18next";

const SUPPORTED_CURRENCIES = [
  { value: "USD", label: "US Dollar (USD)" },
  { value: "EUR", label: "Euro (EUR)" },
  { value: "GBP", label: "British Pound (GBP)" },
  { value: "CAD", label: "Canadian Dollar (CAD)" },
  { value: "AUD", label: "Australian Dollar (AUD)" },
  { value: "JPY", label: "Japanese Yen (JPY)" },
  { value: "CHF", label: "Swiss Franc (CHF)" },
  { value: "CNY", label: "Chinese Yuan (CNY)" },
  { value: "HKD", label: "Hong Kong Dollar (HKD)" },
  { value: "NZD", label: "New Zealand Dollar (NZD)" },
  { value: "PLN", label: "Polish Złoty (PLN)" },
  { value: "SEK", label: "Swedish Krona (SEK)" },
  { value: "NOK", label: "Norwegian Krone (NOK)" },
  { value: "BGN", label: "Bulgarian Lev (BGN)" },
  { value: "CZK", label: "Czech Koruna (CZK)" },
  { value: "DKK", label: "Danish Krone (DKK)" },
  { value: "HUF", label: "Hungarian Forint (HUF)" },
  { value: "RON", label: "Romanian Leu (RON)" },
  { value: "ISK", label: "Icelandic Króna (ISK)" },
  { value: "HRK", label: "Croatian Kuna (HRK)" },
  { value: "TRY", label: "Turkish Lira (TRY)" },
  { value: "BRL", label: "Brazilian Real (BRL)" },
  { value: "IDR", label: "Indonesian Rupiah (IDR)" },
  { value: "ILS", label: "Israeli New Shekel (ILS)" },
  { value: "INR", label: "Indian Rupee (INR)" },
  { value: "KRW", label: "South Korean Won (KRW)" },
  { value: "MXN", label: "Mexican Peso (MXN)" },
  { value: "MYR", label: "Malaysian Ringgit (MYR)" },
  { value: "PHP", label: "Philippine Peso (PHP)" },
  { value: "SGD", label: "Singapore Dollar (SGD)" },
  { value: "THB", label: "Thai Baht (THB)" },
  { value: "ZAR", label: "South African Rand (ZAR)" },
];

interface CurrencySelectorProps {
  value: string;
  onValueChange: (value: string) => void;
}

const CurrencySelector = ({ value, onValueChange }: CurrencySelectorProps) => {
  const { t } = useTranslation();

  return (
    <div className="space-y-2">
      <Label htmlFor="currency">
        {t("settings.currency.preferred")}
      </Label>
      <Select value={value} onValueChange={onValueChange}>
        <SelectTrigger>
          <SelectValue placeholder={t("settings.currency.preferred")} />
        </SelectTrigger>
        <SelectContent>
          {SUPPORTED_CURRENCIES.map((currency) => (
            <SelectItem key={currency.value} value={currency.value}>
              {currency.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
};

export default CurrencySelector;
